var React = require('react');
var Router = require('react-router');
var Link = Router.Link;

var AuthenticationActions = require('../../actions/AuthenticationActions');
var Image = require('../Image');
var Loading = require('../Loading');
var TokenStore = require('../../stores/TokenStore');
var UserStore = require('../../stores/UserStore');

var logoHiRes = require('../../images/infinite-logo-web-hi-res.png');

function getState() {
    return {
        hasUser: UserStore.hasData() && !!UserStore.getUser()
    };
}

var Login = React.createClass({
    contextTypes: {
        router: React.PropTypes.func
    },

    componentDidMount: function() {
        TokenStore.addChangeListener(this._onChange);
        UserStore.addChangeListener(this._onChange);

        AuthenticationActions.authenticate({
            route: this.props.query.route,
            args: this.props.query.args,
            query: this.props.query.query
        });
    },

    componentWillUnmount: function () {
        TokenStore.removeChangeListener(this._onChange);
        UserStore.removeChangeListener(this._onChange);
    },

    componentDidUpdate: function (prevProps, prevState) {
        if (this.state.hasUser) {
            var transitionDestination = this.props.query.route || 'dashboard';

            setTimeout(function() {
                this.context.router.transitionTo(transitionDestination, this.props.query.args, this.props.query.query);
            }.bind(this), 0);
        }
    },

    getInitialState: function () {
        return getState();
    },

    render: function () {
        var dashboard = this.state.hasUser ?
            <fieldset><p><Link to="dashboard">Continue to dashboard..</Link></p></fieldset> :
            null;

        return (<div className="colorful-page-wrapper">
          <div className="center-block">
            <div className="login-block">
                <header>
                    <div className="image-block"><Image desktopSrc={logoHiRes} mobileSrc={logoHiRes} alt="User" /></div>
                    Login to Infinite Portal
                </header>
                <fieldset><p><Loading message="Logging in..." /></p></fieldset>
                {dashboard}
                <footer></footer>
            </div>
          </div>
        </div>);
    },

    _onChange: function() {
        this.setState(getState());
    }
})
module.exports = Login;



// WEBPACK FOOTER //
// ./app/components/Authentication/Login.js